// @flow
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { isBrowser } from 'react-device-detect';
import cx from 'classnames';
import Circles from 'components/common/Loaders/Circles';
import { redirectToSignup } from 'lib/sso';
import Button from '../../common/Button';
import SocialLoginButton from '../SocialLoginButton';

import './LoginForm.scss';

type Props = {
  onChangeEmail(e: Event): void,
  onChangePassword(e: Event): void,
  onChangeOrderId(e: Event): void,
  onChangeOrderEmail(e: Event): void,
  onSendVerification(): Promise<*>,
  onReTryVerification(): Promise<*>,
  onEnterKeyPress(e: KeyboardEvent): void,
  onSocialLogin(provider: string): Promise<*>,
  onSsoLogin(): Promise<*>,
  onSendOrderId(): Promise<*>,
  onNonRegisteredOrderToggle(): void,
  email: string,
  password: string,
  orderId: string,
  orderEmail: string,
  sentEmail: boolean,
  sending: boolean,
  isUser: boolean,
  typeName: string,
  isEmailVerified: boolean,
  isEmailCapitalized: boolean,
  isNonRegisteredOrder: boolean,
  logged: boolean,
  nextUrl: string,
};

const LoginForm = ({
  onChangeEmail,
  onChangePassword,
  onChangeOrderId,
  onChangeOrderEmail,
  onSendVerification,
  onSendOrderId,
  onReTryVerification,
  onNonRegisteredOrderToggle,
  onEnterKeyPress,
  email,
  password,
  orderId,
  orderEmail,
  sentEmail,
  sending,
  isUser,
  onSocialLogin,
  onSsoLogin,
  typeName,
  isEmailVerified,
  isEmailCapitalized,
  isNonRegisteredOrder,
  nextUrl,
}: Props) => {
  useEffect(() => {
    if (this.email) this.email.focus();
    if (this.password) this.password.focus();
  });

  return (
    <div className="LoginForm">
      <Link to="/" className="brand">
        <img src="https://images.cacheby.com/logo.svg" alt="CacheBy" />
      </Link>
      <div className={cx('input-with-button', { sending })}>
        <input
          className="email"
          placeholder="이메일"
          type="email"
          value={email}
          onChange={onChangeEmail}
          disabled={sending}
        />
        <input
          className="password"
          placeholder="비밀번호"
          type="password"
          value={password}
          onChange={onChangePassword}
          disabled={sending}
          onKeyPress={onEnterKeyPress}
        />
        {isEmailCapitalized && (
          <div className="email-validation-warning">대문자를 사용하실 수 없습니다.</div>
        )}
        {/* {!isEmailCapitalized && !isEmailVerified && (
          <div className="email-validation-warning">유효한 이메일 주소가 아닙니다.</div>
        )} */}
        <Button
          fullWidth
          large
          theme="default"
          color="blue"
          onClick={onSendVerification}
          desktop={isBrowser}
        >
          {sending ? <Circles size="small" color="white" text="로그인 중..." /> : '로그인'}
        </Button>
      </div>
      <div className="guideToRegister">
        <span>아직 회원이 아니신가요?</span>
        <span onClick={redirectToSignup} style={{ cursor: 'pointer', textDecoration: 'underline', color: '#3182f6' }}>회원가입</span>
      </div>
      <div className="guideToForgot">
        <span>비밀번호를 잃어버리셨나요?</span>
        <Link to={'/forgot'}>비밀번호 재설정</Link>
      </div>
      {/* SSO 로그인 비활성화 */}
      {/* <div className="separator">
        <div className="or">또는</div>
      </div>
      <div className="sso-login">
        <Button
          fullWidth
          large
          theme="outline"
          color="teal"
          onClick={onSsoLogin}
          desktop={isBrowser}
        >
          SSO 통합 로그인
        </Button>
      </div> */}
      {nextUrl === '/checkout' && (
        <div className="next-url">
          <Button to={'/checkout'} fullWidth large theme="outline" color="blue">
            비회원 구매하기
          </Button>
        </div>
      )}
      {nextUrl !== '/checkout' && (
        <section className="nonRegisteredOrder">
          <button
            type="button"
            className="nonRegisteredOrderBtn"
            onClick={onNonRegisteredOrderToggle}
          >
            비회원 주문 조회하기
          </button>
          {isNonRegisteredOrder && (
            <div className="order-input">
              <input
                className="order-id-input"
                placeholder="주문번호"
                type="text"
                value={orderId}
                onChange={onChangeOrderId}
              />
              <input
                className="order-email-input"
                placeholder="이메일"
                type="email"
                value={orderEmail}
                onChange={onChangeOrderEmail}
              />
              <Button
                fullWidth
                large
                theme="default"
                color="blue"
                onClick={onSendOrderId}
                desktop={isBrowser}
              >
                주문조회
              </Button>
            </div>
          )}
        </section>
      )}
    </div>
  );
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/auth/LoginForm/LoginForm.js